import { useEffect, useState } from 'react';

const USER_ACTIVITY_EXPIRE_TIME = 5000; // 30 seconds

export const useUserActivity = () => {
  const [isUserActive, setIsUserActive] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleMouseMove = () => {
      clearTimeout(timeoutId);
      setIsUserActive(true);

      timeoutId = setTimeout(() => {
        setIsUserActive(false);
      }, USER_ACTIVITY_EXPIRE_TIME);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return { isUserActive };
};
